import React from "react";
import {differenceInDays, endOfDay, startOfDay} from "date-fns";

import {monthNameShortString, onlyDateString, onlyYearString, onlyDayNameString} from "../../services/date/formatters";
import {isValidDateObject} from "../../services/date/validators";

import useTheme from "@mui/material/styles/useTheme";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import PetsIcon from "@mui/icons-material/Pets";


const QuoteInfoBar = props => {
    const {arrival, departure, adults, children, petsNumber} = props;

    const nights = isValidDateObject(arrival) && isValidDateObject(departure) ?
        differenceInDays(endOfDay(departure), startOfDay(arrival)) : 0;

    return (
        <Stack direction="row" alignItems="justify-content" flexGrow={1}>
            <StackedDate date={arrival} label="Da"/>
            <StackedDate date={departure} label="A"/>
            <Nights value={nights} label="Notti"/>
            <Guests adults={adults} children={children} petsNumber={petsNumber} label="Adulti, bambini"/>
        </Stack>
    )
}

const StackedDate = ({date, label}) => {
    const dayName = onlyDayNameString(date);
    const day = onlyDateString(date);
    const month = monthNameShortString(date);
    const year = onlyYearString(date)

    return (
        <Stack alignItems="center" flexGrow={1}>
            <Typography fontWeight='light' fontSize={12}>
                {label}: {dayName}
            </Typography>
            <Typography fontWeight='medium' fontSize="24px">
                {day}
            </Typography>
            <Typography fontWeight='medium' fontSize="12px">
                {month} {year}
            </Typography>
        </Stack>
    )
}

const Guests = ({adults, children, petsNumber, label}) => {
    const theme = useTheme();

    return (
        <Stack alignItems="center" flexGrow={1}>
            <Typography fontWeight='light' fontSize={12}>
                {label}
            </Typography>
            <Typography fontWeight='medium' fontSize="24px">
                {adults}, {children}
            </Typography>
            {
                petsNumber > 0 && <Typography fontWeight='medium' fontSize="12px">
                    con <PetsIcon fontSize="10px" sx={{color: theme.palette.text.primary}}/> x {petsNumber}
                </Typography>
            }
        </Stack>
    )
}

const Nights = ({value, label}) => {

    return (
        <Stack alignItems="center" flexGrow={1}>
            <Typography fontWeight='light' fontSize={12}>
                {label}
            </Typography>
            <Typography fontWeight='medium' fontSize="24px">
                {value}
            </Typography>
        </Stack>
    )
}

export default QuoteInfoBar;